<template>
  <a-layout :bordered="false" class="product">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="36">
          <a-col :span="5">
            <a-form-item :label="$t('business.label.no')">
              <a-input v-model="parameter.itemNo"/>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item :label="$t('business.label.barcode')">
              <a-input v-model="parameter.barcode"/>
            </a-form-item>
          </a-col>

          <a-col :md="4 || 24" :sm="24">
            <span :style="{ float: 'right', overflow: 'hidden' } || {} " class="table-page-search-submitButtons">
              <a-button :loading="loading" @click="queryData" type="primary">{{ $t('button.query') }}</a-button>
              <a-button @click="clearParam" type="primary" style="margin-left: 8px">{{ $t('button.reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      :dataSource="data"
      :loading="loading"
      :pagination="pagination"
      :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
      :rowKey="record => record.key"
      bordered
      size="small">
      <a-table-column :title="$t('business.label.index')" dataIndex="key" width="50px">
        <span slot-scope="text, record, index">
          {{ index + 1 }}
        </span>
      </a-table-column>
      <a-table-column dataIndex="id" title="产品" v-if="show"></a-table-column>
      <a-table-column :title="$t('business.label.no')" dataIndex="no" width="150px">
        <template slot-scope="text,record">
          <a-input
            style="width: 100%"
            :disabled="record.disable"
            v-model="record.item.no">
          </a-input>
        </template>
      </a-table-column>
      <a-table-column :title="$t('business.label.name')" dataIndex="name" width="150px">
        <template slot-scope="text,record">
          <a-input
            style="width: 100%"
            :disabled="record.disable"
            v-model="record.item.name">
          </a-input>
        </template>
      </a-table-column>
      <a-table-column :title="$t('business.label.barcode')" dataIndex="barcode" width="150px">
        <template slot-scope="text,record">
          <a-input
            style="width: 100%"
            :disabled="record.disable"
            v-model="record.pack.barcode">
          </a-input>
        </template>
      </a-table-column>
      <a-table-column :title="$t('business.label.barcode2')" dataIndex="barcode2" width="150px">
        <template slot-scope="text,record">
          <a-input
            style="width: 100%"
            :disabled="record.disable"
            v-model="record.pack.hisBarcode">
          </a-input>
        </template>
      </a-table-column>
      <a-table-column :title="$t('business.label.available')" dataIndex="available" width="150px">
        <template slot-scope="text, record">
          <a-checkbox
            :defaultChecked="true"
            :disabled="record.disable"
            v-model="record.item.available"
          />
        </template>
      </a-table-column>
      <a-table-column :title="$t('business.label.operate')" dataIndex="action" width="150px">
        <template slot-scope="text, record">
          <template>
            <a @click="remove(record)" v-if="record.item.id===''">{{ $t('button.delete') }}</a>
            <a-divider type="vertical"/>
            <a @click="edit(record)">{{ $t('button.edit') }}</a>
          </template>
        </template>
      </a-table-column>
    </a-table>
    <div>
      <a-button @click="newMember" icon="plus" style="width: 100%; margin-top: 1px;margin-bottom: 5px" type="dashed">
        新增商品
      </a-button>
    </div>
    <footer-tool-bar
      :style="{ width: isSideMenu() && isDesktop() ? `calc(100% - ${sidebarOpened ? 256 : 80}px)` : '100%'}">
      <a-button :loading="loading" @click="queryData" type="primary">{{ $t('button.refresh') }}
      </a-button>
      <a-divider type="vertical"/>
      <a-button :loading="loading" @click="handleSave" type="primary">{{ $t('button.save') }}</a-button>
      <a-divider type="vertical"/>
      <a-button :loading="loading" @click="handlePrint" type="primary">{{ $t('button.printTag') }}</a-button>
    </footer-tool-bar>
  </a-layout>
</template>

<script>
  import api from '@/api';
  import {findAll, post, save} from '@/api/Api';
  import {mixin, mixinDevice} from '@/utils/mixin'
  import FooterToolBar from '@/components/FooterToolbar'
  import moment from 'moment'
  import {validateFields} from '@/utils/field-check'
  import Vue from 'vue'

  export default {
    name: 'Product',
    mixins: [mixin, mixinDevice],
    components: {
      FooterToolBar
    },
    data: function () {
      return {
        //pageSize:5,
        //current:1,
        pagination: {
          pageSize: 5,
          current: 1,
          defaultPageSize: 5,
          showQuickJumper: true,
          // showTotal: total => `共 ${total} 条数据`,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '15', '20'],
          onShowSizeChange: (current, pageSize) => {
            this.pagination.pageSize = pageSize
          },
          onChange: (current) => {
            this.pagination.current = current
          }
        },
        form: this.$form.createForm(this),
        loading: false,
        // data: [{ 1: 1, 2: 2, 3: 3 }],
        data: [],
        show: false,
        invoiceTime: '',
        status: '',
        parameter: {itemNo: '', barcode: ''},
        selectedRowKeys: [],
        selectedRows: []
      }
    },
    mounted() {
      this.queryData()
    },
    methods: {
      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      moment,
      getCurrentData() {
        return new Date().toLocaleDateString()
      },
      newMember() {
        const newData = [...this.data]
        const length = newData.length
        console.log(length, 'length')
        const record = {
          key: length === 0 ? '1' : (parseInt(this.data[length - 1].key) + 1).toString(),
          item: {id: '', no: '', name: '', available: true},
          pack: {barcode: '', barcode2: ''},
          disable: false
        }
        console.log(record, 'record')
        newData.push(record)
        this.data = newData
        this.pagination.current = (Math.ceil(this.data.length / this.pagination.pageSize))
        console.log(this.current, 'current')
      },

      remove(record) {
        this.loading = true
        const rec = JSON.parse(JSON.stringify(record))
        if (rec.item.id === '') {
          this.data = this.data.filter(r => r.key !== rec.key)
        }
        this.loading = false
      },
      edit(record) {
        this.loading = true
        record.disable = false
        this.loading = false
      },
      queryData() {
        this.loading = true
        this.data = []
        return findAll('itemPackFactory', this.parameter)
          .then(
            res => {
              console.log('res=>', this.data)
              res.forEach(r => {
                r.disable = true
                //r.editStaus='编辑'
                r.key = this.data.length === 0 ? '1' : (parseInt(this.data[this.data.length - 1].key) + 1).toString()
                this.data.push(r)
              })
              this.loading = false
            })
      },
      clearParam() {
        this.parameter = {itemNo: '', barcode: ''}
      },
      async handleSave() {
        await new Promise((resolve, reject) => {
          this.data.filter(r => !r.disable).forEach(rec => {
            save('itemPackPersister', rec, {verifiable: false}).then(response => {
              console.log(rec.id)
              resolve(true)
            }).catch(err => {
              reject(err)
              this.requestFailed(err)
            })
          })
        }).then(res => {
          this.$message.success('保存成功！')
          this.queryData()
        })
      },
      print(value) {
        return new Promise((resolve, reject) => {
          post(api.Print, {}, value)
            .then((body) => {
              resolve(true)
            })
            .catch((err) => {
              this.requestFailed(err)
              console.log(err, 'err')
              reject(false)
            })

        })
      },


      handlePrint() {
        const arr = []
        if (this.selectedRows.length > 0) {
          this.loading = true
          for (let i = 0; i < this.selectedRows.length; i++) {
            const map = new Map()
            map.set('print.no', 'barcode')
            map.set('mac', 'SHZCQ')
            // map.set('mac', this.executor.workstation.name)


            const factoryArgs = new Map()
            factoryArgs.set('printNo', this.selectedRows[i].pack.barcode)
            const args = validateFields(factoryArgs)
            map.set('parameter', args)
            const returnValue = validateFields(map)

            arr.push(this.print(returnValue))
          }
          Promise.all(arr)
            .then((arr) => {
              this.$message.success('打印完成')
              this.selectedRowKeys = []
              this.selectedRows = []
            })
            .finally(() => {
              this.loading = false
            })


        } else {
          Vue.prototype.$warning({
            title: '提示',
            content: '未选择打印的条码'
          })
        }
      }
    }

  }
</script>

<style lang="less" scoped>
  .product {
    input {
      /*width: 100%;*/
      /*height: 100%;*/
      /*position:relative;*/
      /*padding-left: 0.533333rem;*/
      /*border-radius:0.4rem;*/
      color: #3868cf;
      /*font-size: 0.426667rem;*/
      //text-align: vertical-align;
      /*font-family:PingFangSC-Regular;*/
      /*font-weight: 400;*/
      /*background: rgba(248, 248, 248, 1);*/
      /*line-height: 0.586667rem;*/
    }

  }

</style>